import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { Navigation } from 'swiper/modules';
import styles from './Motability7SelectedCarCarousel.module.scss';
import Slide from './Slide/Motability7Slide';

export default function SelectedCarCarousel({ swiperRef, newCarouselData, setSlideIndex }) {
  return (
    <div className={styles.wrapper}>
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        slidesPerView={1}
        spaceBetween={0}
        centeredSlides
        modules={[Navigation]}
        onSlideChange={(swiper) => setSlideIndex(swiper.activeIndex)}
      >
        {newCarouselData.map((slide) => (
          <SwiperSlide key={slide.index}>
            <Slide key={slide.index} slide={slide} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
